import { render, staticRenderFns } from "./ssoKundreskontraWidget.vue?vue&type=template&id=781c209c&"
import script from "./ssoKundreskontraWidget.vue?vue&type=script&lang=js&"
export * from "./ssoKundreskontraWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\TeamCity\\Edison.Sso\\Dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781c209c')) {
      api.createRecord('781c209c', component.options)
    } else {
      api.reload('781c209c', component.options)
    }
    module.hot.accept("./ssoKundreskontraWidget.vue?vue&type=template&id=781c209c&", function () {
      api.rerender('781c209c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "v-components/widgets/ssoKundreskontraWidget.vue"
export default component.exports